import React, { ReactNode } from 'react'
import MultiUpload from '../../commonfields/MultiUpload';
import { Accept } from 'react-dropzone';

interface IFileUploadContainersProps {
  files: any;
  handleFileChange: Function;
  label?: ReactNode | string;
  btnlabel?: ReactNode | string;
  maxFiles?: number;
  displayInput?: boolean;
  displayFilesContent?: boolean;
  accept?: Accept;
  disabled?:boolean;
}

const FileUploadContainers = (props: IFileUploadContainersProps) => {
  const { files, handleFileChange, displayInput, label, btnlabel, maxFiles, displayFilesContent, accept, disabled } = props;

  return (
    <div className="file-upload-container">
      {label ? <div className="label file-label">{label}</div> : <></>}
      <MultiUpload 
        files={files}
        handleFileChange={handleFileChange}
        displayInput={displayInput ?? true}
        maxFiles={maxFiles || 1}
        labelName={btnlabel}
        displayFilesContent={displayFilesContent}
        accept={accept}
        disabled={disabled}
      />
    </div>
  )
}

export default FileUploadContainers